import { throwIfRetryableResponse } from 'features/Auth/connectivity'

import { unscopedApiClient } from '../../unscopedApiClient'

export interface ForgeSettings {
    displayDowntimePage: boolean
    displayMaintenancePage: boolean
    globalNotification: {
        [key: string]: any
    }
}

export const getForgeSettings = async (): Promise<ForgeSettings> => {
    const response = await unscopedApiClient.get(`api/application_settings/`)
    // Throttling is not a verdict on downtime; let the caller retry.
    throwIfRetryableResponse(response)
    const {
        data: { results },
        status,
    } = response

    if (status === 200) {
        const settings: {
            [key: string]: any
        } = {}
        results.forEach((item: any) => {
            settings[item.name] = item.value
        })

        let globalNotification = {}
        try {
            globalNotification = JSON.parse(
                settings.global_notification ?? '{}'
            )
        } catch (err) {
            console.error(
                'error while parsing the global notification (banner)',
                err
            )
        }

        return {
            displayDowntimePage: false,
            displayMaintenancePage:
                settings.display_maintenance_page === 'true',
            globalNotification,
        }
    }

    return {
        displayDowntimePage: true,
        displayMaintenancePage: false,
        globalNotification: {},
    }
}
